import type { AxiosError } from "axios";
import { AbortError, ApiErrorCode } from "@/constants/index";
import { Toast } from "@/ui-kit";
import type { IServerError } from "@/types/common";

export const serverErrorHandler = (onError?: () => void) => {
  return (error: AxiosError<IServerError>) => {
    if (
      error?.response?.status !== ApiErrorCode.Unauthorized &&
      error?.name !== AbortError
    ) {
      Toast.error({
        title: error?.response?.data?.error || error?.message,
      });
      onError?.();
    }
  };
};
